export default __webpack_public_path__ + "static/media/cg.c4f536d8.svg";